// import components
import { ChevronRight, ExpandMore } from '@mui/icons-material';
import { BoxProps } from '@mui/material';

// import hooks and utils
import {
  gridFilteredDescendantCountLookupSelector,
  GridRenderCellParams,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid-pro';

// import styles
import {
  StyledCustomTreeDataContainerBox,
  StyledTreeDataChildBox,
  StyledTreeDataIcon,
  StyledTreeDataIconBox,
  StyledTreeDataParentBox
} from './CustomGridTreeDataGroupingCell.styles';

export const CustomGridTreeDataGroupingCell = (props: GridRenderCellParams) => {
  const { id, rowNode, row } = props;
  const apiRef = useGridApiContext();
  const filteredDescendantCountLookup = useGridSelector(
    apiRef,
    gridFilteredDescendantCountLookupSelector
  );
  const filteredDescendantCount =
    filteredDescendantCountLookup[rowNode.id] ?? 0;

  const handleClick: BoxProps['onClick'] = () => {
    if (rowNode.type !== 'group') {
      return;
    }

    apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
  };

  return (
    <StyledCustomTreeDataContainerBox
      onClick={(event) => event.stopPropagation()}
      rowNodeDepth={rowNode.depth * 12}
    >
      {rowNode.type === 'group' ? (
        <StyledTreeDataParentBox tabIndex={-1}>
          <StyledTreeDataIconBox onClick={handleClick}>
            {rowNode.childrenExpanded ? <ExpandMore /> : <ChevronRight />}
          </StyledTreeDataIconBox>
          <StyledTreeDataIcon type="folder" fontSize="small" color="primary" />
          {row.name} ({filteredDescendantCount})
        </StyledTreeDataParentBox>
      ) : (
        <StyledTreeDataChildBox>{row.name}</StyledTreeDataChildBox>
      )}
    </StyledCustomTreeDataContainerBox>
  );
};
